// @mui material components
import { createTheme } from "@mui/material/styles";
import GothamBookRegular from "./fonts/GothamBookRegular.woff";

// base styles
import borders from "./base/borders";
import boxShadows from "./base/boxShadows";
import breakpoints from "./base/breakpoints";
import colors from "./base/colors";
import globals from "./base/globals";
import typography from "./base/typography";

// helper functions
import boxShadow from "./functions/boxShadow";
import hexToRgb from "./functions/hexToRgb";
import linearGradient from "./functions/linearGradient";
import pxToRem from "./functions/pxToRem";
import rgba from "./functions/rgba";

// components base styles for @mui material components
import appBar from "./components/appBar";
import card from "./components/card";
import datagrid from "./components/datagrid";
import iconButton from "./components/iconButton";
import inputBase from "./components/inputBase";
import list from "./components/list";
import listItem from "./components/listItem";
import listItemText from "./components/listItemText";
import menu from "./components/menu";
import menuItem from "./components/menuItem";
import sidenav from "./components/sidenav";
import switchButton from "./components/switchButton";
import tooltip from "./components/tooltip";

import autocomplete from "./components/autocomplete";
import input from "./components/input";
import link from "./components/link";
import svgIcon from "./components/svgIcon";
import textField from "./components/textField";
import props from "./props";

export const functions = {
  boxShadow,
  hexToRgb,
  linearGradient,
  pxToRem,
  rgba,
};

export const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
};

declare module "@mui/material/styles" {
  // base Theme extensions
  interface ThemeOptions {
    boxShadows?: typeof boxShadows;
    borders?: typeof borders;
    functions?: typeof functions;
    props: typeof props;
  }
  interface Theme {
    boxShadows: typeof boxShadows;
    borders: typeof borders;
    functions: typeof functions;
    props: typeof props;
  }
  interface PaletteOptions {
    vidletColors?: typeof colors.vidletColors;
    script?: typeof colors.script;
  }
  interface Palette {
    vidletColors: Record<string, string>;
    script: Record<string, string>;
  }
  interface Components {
    MuiDataGrid;
  }
}

const theme = createTheme({
  boxShadows,
  borders,
  functions,
  props,
  breakpoints,
  palette: colors,
  typography: {
    ...typography,
    button: {
      ...typography.button,
      textTransform: "uppercase",
    },
  },
  zIndex,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        styleOverrides: `
        @font-face {
          font-family: "Gotham Book Regular";
          src: url(${GothamBookRegular}) format("woff");
      }
      `,
      },
    },
    MuiAppBar: appBar,
    MuiAutocomplete: autocomplete,
    MuiCard: card,
    MuiDataGrid: datagrid,
    MuiDrawer: sidenav,
    MuiIconButton: iconButton,
    MuiInput: input,
    MuiInputBase: inputBase,
    MuiLink: link,
    MuiList: list,
    MuiListItem: listItem,
    MuiListItemText: listItemText,
    MuiMenu: menu,
    MuiMenuItem: menuItem,
    MuiSvgIcon: svgIcon,
    MuiSwitch: switchButton,
    MuiTextField: textField,
    MuiTooltip: tooltip,
  },
});
export default theme;
